import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { registerServiceWorker } from './service-worker'

async function main() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )

  // Register service worker for PWA support
  registerServiceWorker()

  // Listen for SW updates
  window.addEventListener('sw-update', () => {
    console.log('📦 App update available - reload to apply')
  })

  // Monitor online/offline status
  window.addEventListener('online', () => {
    console.log('🟢 Back online - syncing data...')
  })

  window.addEventListener('offline', () => {
    console.log('🔴 Offline mode - using cached data')
  })
}

main()
